import { useCallback } from "react";
import { useAuthUser } from "./useAuthUser";
import {
  CustomerManagementIntroducingBrokerStatusEnum,
  INTRODUCING_BROKER_APPLY_ROUTE,
  INTRODUCING_BROKER_ROUTE,
} from "_constants";

export const useSanitizeRoutes = () => {
  const { user } = useAuthUser();
  const sanitizeRoutes = useCallback(
    (routes) => {
      let currentRoutes = [...routes];

      if (
        user?.ibStatus !==
        CustomerManagementIntroducingBrokerStatusEnum.Approved
      ) {
        currentRoutes = currentRoutes.filter(
          ({ path }) =>
            !(
              path !== INTRODUCING_BROKER_ROUTE &&
              path !== INTRODUCING_BROKER_APPLY_ROUTE &&
              path.includes(INTRODUCING_BROKER_ROUTE)
            )
        );
      }

   

      return currentRoutes;
    },
    [user?.ibStatus]
  );

  return { sanitizeRoutes };
};
